// Отказы «Обновить» (`POST submit-update`) — одно правило на курс и статью. Словарь тот же,
// что у смены видимости (`parseModerationError`), но тексты свои: здесь не «доступ», а обновление.
import { toast } from 'sonner'
import type { ValidationError } from '@/types/api'
import { jobTypeLabel } from '@/features/ai/lib/jobTypeLabel'
import type { ModerationFailure } from './parseModerationError'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

/** Русская строка — для старых потребителей-констант; тосты берут текст на языке интерфейса. */
export const UPDATE_FAILED_TEXT = messages.ru.updateFailed

const updateFailed = (): string => messagesNow(messages).updateFailed

export interface UpdateFailureHandlers {
  refetch: () => void
  /** `429 review_rate_limited` — бизнес-антиспам: отсчёт на кнопке, без тоста. */
  startCountdown: (sec: number) => void
  /** Список проблем валидатора (у курса — диалог). Нет обработчика — общий тост. */
  onValidation?: (errors: ValidationError[]) => void
}

export const handleUpdateFailure = (failure: ModerationFailure, h: UpdateFailureHandlers): void => {
  switch (failure.kind) {
    case 'validation':
      if (h.onValidation) h.onValidation(failure.errors)
      else toast.error(updateFailed())
      return
    case 'no_changes':
      toast.error(messagesNow(messages).noChanges)
      h.refetch()
      return
    case 'in_progress':
      h.refetch()
      return
    case 'job_busy':
      toast.error(messagesNow(messages).waitForRun(jobTypeLabel(failure.jobType)))
      return
    case 'rate_limited':
      h.startCountdown(failure.retryAfterSec)
      return
    case 'not_allowed':
      // `submit-update` этот код не отдаёт (контракт §3a), но словарь общий — перечитываем
      // состояние, как и смена видимости, чтобы кнопки встали по правам.
      toast.error(updateFailed())
      h.refetch()
      return
    case 'draft_course':
      // Ручку позвали по id черновика: состояние устарело — перечитываем, как `not_allowed`.
      toast.error(updateFailed())
      h.refetch()
      return
    case 'unknown':
      toast.error(updateFailed())
      return
    default: {
      const unreachable: never = failure
      return unreachable
    }
  }
}
